import config from '@/config';
import { LogicContext } from '@/logic/main/types';
import { getCategory } from '@/logic/main/utils';
import Window from '@/ports-frontend/Window';
import { getLocale } from '@/utils';

export const getCategoriesLayoutContent = async (context: LogicContext) => {
  const {
    shuffleGames,
    multiJackpots,
    currentJackpotsV2,
    currentTables,
    currentPersonalizedBanners,
    controllersData,
    user,
    strikeGoldData,
    pageMainTitle,
  } = context;
  const locale = getLocale(config);
  const currency = user?.currency || config.default_currency;
  const { loggedIn, firstName } = user;
  const { drawnGame } = shuffleGames;
  if (!controllersData?.categories) {
    return {
      updates: [],
    };
  }
  const windowInnerWidth = await Window.getInnerWidth();

  const categoriesOnPage = controllersData.categories!.components.filter(
    ([id, v]) => v.type === 'Category'
  ).length;
  const updates = controllersData.categories!.components.map(([id, entry]) => ({
    type: 'setLayoutProperty',
    data: {
      path: `components.${id}.properties`,
      value: {
        pageTitle: pageMainTitle,
        category: getCategory({
          category: {
            ...entry.properties,
            title: entry.properties.title?.replace('{{userName}}', firstName),
            categoriesOnPage,
          },
          multiJackpots,
          currentJackpotsV2,
          currentTables,
          currentPersonalizedBanners,
          shuffleGame: drawnGame,
          windowInnerWidth,
          currency,
          locale,
          strikeGoldData,
        }),
        currency,
        loggedIn,
        locale,
        visible: !context.isGameModalForMobileOpened,
      },
    },
  }));

  return {
    updates,
  };
};
